import Vue from 'vue';
import VueRouter from 'vue-router';

import Start from '../views/2_MailDN_Error/MailDN.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Start },

    { path: '*', redirect: '/' }
  ]
});

export default router;